import { render, staticRenderFns } from "./bussiness.vue?vue&type=template&id=6cb6c32c&scoped=true"
import script from "./bussiness.vue?vue&type=script&lang=js"
export * from "./bussiness.vue?vue&type=script&lang=js"
import style0 from "./bussiness.vue?vue&type=style&index=0&id=6cb6c32c&prod&scoped=true&lang=css"
import style1 from "./bussiness.vue?vue&type=style&index=1&id=6cb6c32c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb6c32c",
  null
  
)

export default component.exports